<template>
    <!-- Footer-->
    <footer class="bg-white py-4 mt-auto">
        <div class="container px-5">
            <div class="row align-items-center justify-content-between flex-column flex-sm-row">
                <div class="col-auto">
                    <div class="small m-0">&copy; {{ getYear() }} <a href="https://periapsys.com">Periapsys.com</a>. All
                        Rights Reserved </div>
                </div>
                <div class="col-auto">
                    <router-link class="small" to="/privacy">Privacy</router-link>
                    <span class="mx-1">&middot;</span>
                    <router-link class="small" to="/terms">Terms</router-link>
                    <span class="mx-1">&middot;</span>
                    <a class="small" href="https://periapsys.com/#contact">Contact</a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    methods: {
        getYear() {
            return new Date().getFullYear();
        }
    }
}
</script>